import { MethodsOfPayment } from '@e-origin/shared';

/**
 * Cross-field rules - the ones a per-field schema cannot express because they read a sibling.
 *
 * Pure and free of any UI import, so it runs in the node suite. Lives here rather than in the
 * component so the rule has ONE definition: `fields.base.ts` wires it to the currency fields'
 * `validate` slot, and the component renders the same message inline (immediately, as it does
 * today, rather than waiting for blur).
 */

export const CHARGES_CURRENCY_MESSAGE = 'Currency is required when charges amount is specified';

/** Verbatim from ChargesImportSection: a positive amount with no currency picked. */
export const isCurrencyMissing = (amount: number | string | undefined, currency: string | undefined): boolean => {
  const numeric = typeof amount === 'string' ? parseFloat(amount) : amount;

  return !!(numeric && numeric > 0 && !currency);
};

export const VAT_D_PAYMENT_WARNING = 'To use D for VAT payment, please provide E and DPO account in Duties section';

/**
 * Verbatim from `@utils`'s `isVatDeferredPaymentInvalid` - copied rather than imported because
 * `@utils` reaches `js-cookie`/`axios`/`@e-origin/crypto-wasm`, which the node suites cannot load.
 * VAT payment method "D" (OTHER) requires method "E" (deferred/postponed) with a non-blank deferred
 * payment account; anything else paired with "D" is invalid.
 */
export const isVatDeferredPaymentInvalid = (payment: {
  methodOfPaymentVAT?: string | null;
  methodOfPayment?: string | null;
  deferredPayment?: string | null;
}): boolean =>
  payment.methodOfPaymentVAT === MethodsOfPayment.OTHER &&
  !(payment.methodOfPayment === MethodsOfPayment.DEFERRED_OR_POSTPONED_PAYMENT && Boolean(payment.deferredPayment?.trim()?.length));
